import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {bigWinEvents} from "../views/WinTextView";
import {TweenLite} from "gsap";

export class ImmortalFruitsBackground extends BaseView {
    private bgSpine:PIXI.spine.Spine;
    private bgSpineStatic:PIXI.spine.Spine;
    private bg_lines:PIXI.spine.Spine;
    private bgBIGWINSpine:SpineTween;
    private bgIDLESpine:SpineTween;
    private shouldPlayIdle:boolean=false;
    private isBigWinPlaying:boolean=false;
    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        const layer: ScalableLayer = StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.BACKGROUND.name),
            pos: number = 360;
        this.bgSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("bg_animation"));
        this.bgSpineStatic = new PIXI.spine.Spine(GameResources.getSpineAsset("bg_animation"));
        this.bg_lines = new PIXI.spine.Spine(GameResources.getSpineAsset("bg_lines"));
        this.bgSpine.pivot.set(0.5);
        this.bgSpineStatic.pivot.set(0.5);
        this.bg_lines.pivot.set(0.5);

        layer.addChild(this);

        this.bgSpine.position.set(pos);
        this.bgSpineStatic.position.set(pos);
        this.bg_lines.position.set(pos);
        new SpineTween(this.bgSpineStatic, 0, "bg_static", -1);
        this.bg_lines.renderable =false;
        this.bgSpine.renderable =false;
        this.bgSpineStatic.renderable =true;
        this.addChild(this.bgSpine);
        this.addChild(this.bgSpineStatic);
        this.addChild(this.bg_lines);
    }
    private playSpineAnimation(level:string){
        this.bgSpineStatic.renderable =false;
        this.bgSpine.renderable =true;

        switch (level) {
            case "Big Win":
                this.isBigWinPlaying = true;
                this.bgBIGWINSpine = new SpineTween(this.bgSpine, 0, "bigwin_bg_animation", -1);
                break;
            case "Mega Win":
                this.isBigWinPlaying = true;
                this.bgBIGWINSpine = new SpineTween(this.bgSpine, 0, "megawin_bg_animation", -1);
                break;
            case "Super Mega Win":
                this.isBigWinPlaying = true;
                this.bgBIGWINSpine = new SpineTween(this.bgSpine, 0, "superwin_bg_animation", -1);
                break;
            case "medium":
            case "large":
                this.bgIDLESpine =  new SpineTween(this.bgSpine, 0, "bg_idle_animation", -1);
                break;
            default:
                this.shouldPlayIdle =true;
                this.playBgIdleAnim(level);
                break;
        }
    }
    private playBgIdleAnim(level:string){
        this.bgIDLESpine = new SpineTween(this.bgSpine, 0, "bg_idle_animation", 0);
        TweenLite.to(() => {}, 2*this.bgIDLESpine.duration()-0.1, {onComplete: () => {
                if(this.shouldPlayIdle ){
                    this.stopBGAnimation();
                    this.playBgLines();
                }

            }});
        TweenLite.to(() => {},this.bgIDLESpine.duration(),{onComplete:()=>{
                if(this.shouldPlayIdle ) {

                    this.bgSpine.state.setAnimation(0,"bg_idle_reverse",false);
                    //.tracks[0].timeScale = -1;
                }

            }});
    }
    private playBgLines(){
        this.bg_lines.renderable =true;
        this.bg_lines.state.setAnimation(0,"bg_lines",false).timeScale =1.2;
    }

    private stopBGAnimation(){

        this.bg_lines.renderable =false;
        this.bgSpineStatic.renderable =true;
        if( this.isBigWinPlaying ){

            this.bgSpineStatic.alpha =0;
            TweenLite.to(this.bgSpineStatic,0.25,{alpha:1,onComplete:()=>{

                }});
            TweenLite.to(this.bgSpine,0.25,{alpha:0,onComplete:()=>{
                    this.bgSpine.renderable =false;
                    this.bgBIGWINSpine &&  this.bgBIGWINSpine.clear();
                    this.bgBIGWINSpine &&  this.bgBIGWINSpine.kill();
                    this.bgSpine.alpha =1;
                }});

        }else{
            this.bgSpine.renderable =false;
            this.bgBIGWINSpine &&  this.bgBIGWINSpine.clear();
            this.bgBIGWINSpine &&  this.bgBIGWINSpine.kill();
            this.bgSpineStatic.renderable =true;
            new SpineTween(this.bgSpineStatic, 0, "bg_static", -1);
        }
        this.shouldPlayIdle =false;
        this.isBigWinPlaying =false;

    }
    protected addEventListeners(){
        EventHandler.addEventListener(this, bigWinEvents.PLAY_BIGWIN, (event: GameEvent) => this.playSpineAnimation(event.params[0]));
       // EventHandler.addEventListener(this, bigWinEvents.PLAY_BACKGROUNDLINES, (event: GameEvent) => this.playBgLines());
        EventHandler.addEventListener(this, bigWinEvents.STOP_BIGWIN, () => this.stopBGAnimation());

    }
}